export default {
    top: "Photos from top: ",
    credit: "Photo credit: ",
}